export default __webpack_public_path__ + "navigation-examples-location-snapping-thumbnail-960-9ee702d8ebdc3d6ba7e78657ad8257ea.webp";